export const selectStyle = {
    
    control: (provided, state) => ({
        ...provided,
        border: state.isFocused ? '1px solid rgb(203 213 225)' : '1px solid rgb(203 213 225)',
        boxShadow: state.isFocused ? 'none' : 'none',
        '&:hover': {
            border: state.isFocused ? '1px solid rgb(203 213 225)' : '1px solid rgb(203 213 225)', // Apply blue border on hover if focused, otherwise regular border
        },
        minHeight: "30px", 
        width: '100%',
        cursor: 'pointer',
        borderRadius: '5px',
    }),


    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),

        
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 2px 2px 8px',
    }),

    indicatorsContainer: (provided) => ({
        ...provided,
        //  display: 'none',  
        padding: '0px',
    }),

    dropdownIndicator: (provided) => ({
        ...provided,
        //display: 'none', 
        color: 'rgb(148 163 184)',
        padding: '4px',
        "svg": {
            width: '14px',
            height: '14px',
        }
    }),

    clearIndicator: (provided) => ({
        ...provided,
        //display: 'none', 
        color: 'rgb(148 163 184)',
        padding: '0px',
        "svg": {
            width: '14px',
            height: '14px',
        }
    }),

    option: (styles, { isDisabled, isFocused, isSelected }) => {
        let backgroundColor;
        let color;
        let cursor = isDisabled ? 'not-allowed' : 'pointer';

        if (isDisabled) {
            backgroundColor = undefined;
            color = 'var(--text-color)';
        } else if (isSelected) {
            backgroundColor = '#f1f1f1';
            color = undefined;
        } else if (isFocused) {
            backgroundColor = '#f1f1f1';
            color = 'var(--text-color)';
        } else {
            backgroundColor = undefined;
            color = 'var(--text-color)';
        }

        let activeBackgroundColor;
        if (!isDisabled) {
            if (isSelected) {
                activeBackgroundColor = '#fff';
            } else {
                activeBackgroundColor = '#fff';
            }
        }

        return {
            ...styles,
            fontSize: '12px',
            color: 'var(--text-color)',
            padding: '5px 10px ',
            backgroundColor: backgroundColor,
            cursor: cursor,
            ':active': {
                ...styles[':active'],
                backgroundColor: backgroundColor,
            },
        };
    },

    placeholder: (provided, state) => ({
        ...provided,
        color: "rgb(71 85 105 / 60%)",
        fontSize: "12px",
    }),

    singleValue: (provided, state) => ({
        ...provided,
        color: "var(--text-color)",
        fontSize: "12px",
    }),

    input: (provided, state) => ({
        ...provided,
        color: "var(--text-color)",
        fontSize: "13px",
        margin: '0px',
        paddingTop: '1px',
        paddingBottom: '1px',
    }),

    menu: (provided, state) => ({
        ...provided,
        zIndex: "2",
      }),
  

};

 